import { render, staticRenderFns } from "./InfoMessageBox.vue?vue&type=template&id=781d0cc5"
import script from "./InfoMessageBox.vue?vue&type=script&lang=js"
export * from "./InfoMessageBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports